export const SET_SUB_STEP = 'SET_SUB_STEP'
export const SET_CO_APPLICANT = 'SET_CO_APPLICANT'
export const SET_OPEN_VERIFICATION = 'SET_OPEN_VERIFICATION'
export const SET_COMPANY_VERIFICATION_METHOD = 'SET_COMPANY_VERIFICATION_METHOD'
export const SET_APPLICATION_COMPLETE = 'SET_APPLICATION_COMPLETE'
export const SET_PERSON_DATA = 'SET_PERSON_DATA'
export const SET_PARTNER_DETAILS = 'SET_PARTNER_DETAILS'
export const SET_FUND_DETAILS = 'SET_FUND_DETAILS'
export const SET_SINGPASS_INFO = 'SET_SINGPASS_INFO'
export const SET_LOAN_STEP = 'SET_LOAN_STEP'
export const SET_LOAN_SUB_STEP = 'SET_LOAN_SUB_STEP'
export const SET_ENTITY_DATA = 'SET_ENTITY_DATA'
export const SET_LOAN_APPLICATION = 'SET_LOAN_APPLICATION'
export const SET_AGENT_DETAILS = 'SET_AGENT_DETAILS'
